<template lang="pug">
  include ./../../../mixins
  +b.tab(
    v-if="isActive"
  )
    slot()
</template>

<script>
export default {
  name: 'TabUi',

  props: {
    name: {
      type: String,
    },
    selected: {
      type: Boolean,
    },
  },

  data() {
    return {
      isActive: false,
    }
  },

  mounted() {
    this.isActive = this.selected
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/UiTabs/TabUi.vue